// src/components/admin/AdminSidebar.jsx
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Star,
  Sparkles,
  Award,
  UserRound,
  BookOpen,
  Upload,
  FileText,
  ListChecks
} from 'lucide-react';

const AdminSidebar = () => {
  const navItems = [
    { to: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/admin/top-picks', icon: Star, label: 'Top Picks Pool' },
    { to: '/admin/new-releases', icon: Sparkles, label: 'New Releases' },
    { to: '/admin/book-of-week', icon: Award, label: 'Book of the Week' },
    { to: '/admin/author-spotlight', icon: UserRound, label: 'Discover Author' },
    { to: '/admin/curated-lists', icon: ListChecks, label: 'Curated Lists' },
    { to: '/admin/books-library', icon: BookOpen, label: 'Books Library' },
    { to: '/admin/bulk-import', icon: Upload, label: 'Bulk Import' },
    { to: '/admin/logs', icon: FileText, label: 'Logs' }
  ];

  return (
    <div className="w-64 bg-bg-surface border-r border-gray-200 h-full flex flex-col">
      {/* Logo/Title */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-2">
          <img
            src="/icon.png"
            alt="Bukito"
            className="w-8 h-8 rounded-lg"
          />
          <div>
            <div className="text-lg font-bold text-primary-500">Bukito</div>
            <div className="text-xs text-text-secondary">Admin Panel</div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <div className="space-y-2">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/admin'}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-primary-50 text-primary-700 border border-primary-200'
                    : 'text-text-secondary hover:text-text-primary hover:bg-gray-50'
                }`
              }
            >
              <Icon className="w-5 h-5" />
              <span className="text-sm font-medium">{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        <div className="text-xs text-text-secondary">
          Bukito Admin v1.0
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
